import { render, staticRenderFns } from "./FinishedPage.vue?vue&type=template&id=370ed0ce&"
import script from "./FinishedPage.vue?vue&type=script&lang=js&"
export * from "./FinishedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports